import diaryService from './diary.Service';

export default diaryService;
